const DUTCH_IBAN_GROUPS = [4, 4, 4, 4, 2]

export const DUTCH_IBAN_LENGTH = 18
export const FORMATTED_DUTCH_IBAN_LENGTH = 22

export const normalizeDutchIban = (iban: string = ''): string =>
  iban.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, DUTCH_IBAN_LENGTH)

export const formatDutchIban = (iban: string = ''): string => {
  const normalizedIban = normalizeDutchIban(iban)
  const groups: string[] = []
  let start = 0

  DUTCH_IBAN_GROUPS.forEach(groupLength => {
    const group = normalizedIban.slice(start, start + groupLength)

    if (group) {
      groups.push(group)
    }

    start += groupLength
  })

  return groups.join(' ')
}

const getIbanCheckDigits = (iban: string): string => `${iban.slice(4)}${iban.slice(0, 4)}`

const calculateModulo = (iban: string): number => {
  let remainder = 0

  for (const character of getIbanCheckDigits(iban)) {
    if (/[A-Z]/.test(character)) {
      const characterValue = String(character.charCodeAt(0) - 55)

      for (const digit of characterValue) {
        remainder = (remainder * 10 + Number(digit)) % 97
      }
    } else {
      remainder = (remainder * 10 + Number(character)) % 97
    }
  }

  return remainder
}

export const isValidDutchIban = (iban: string = ''): boolean => {
  const normalizedIban = normalizeDutchIban(iban)

  if (!/^NL\d{2}[A-Z]{4}\d{10}$/.test(normalizedIban)) {
    return false
  }

  return calculateModulo(normalizedIban) === 1
}
